import {Box, Flex} from '@chakra-ui/react'
import HybridLink from '../hybrid-link'
import {CONTACT_US_HREF, HYBRID_CUSTOMER_SERVICE} from '../../constants'
import {QuestionMarkIcon} from '../icons'
import {FormattedMessage} from 'react-intl'
import LocaleSelector from '../locale-selector'
import React from 'react'

/**
 * Renders application links on mobile drawer bellow the dynamic portion
 */
const DrawerApplicationLinks = () => {
    return (
        <Flex
            flexDirection="column"
            alignItems="flex-start"
            gap={2}
            padding={4}
            borderColor="stokkeGray.mid"
        >
            <Box padding={2}>
                <HybridLink page={HYBRID_CUSTOMER_SERVICE} to={CONTACT_US_HREF} size="sm">
                    <QuestionMarkIcon boxSize={4} marginInlineEnd={2} />
                    <FormattedMessage id="global.help" defaultMessage="Help" />
                </HybridLink>
            </Box>

            <Box padding={2}>
                <LocaleSelector />
            </Box>
        </Flex>
    )
}

export default DrawerApplicationLinks
